import combinedGACall from '../combinedGACall';

export default (action, label) =>
	combinedGACall({
		category: 'Vaccinated employees',
		action,
		...(label ? { label } : null),
	});
